import { render, staticRenderFns } from "./ForeignCessationApplications.vue?vue&type=template&id=00bad48a&scoped=true&"
import script from "./ForeignCessationApplications.vue?vue&type=script&lang=js&"
export * from "./ForeignCessationApplications.vue?vue&type=script&lang=js&"
import style0 from "./ForeignCessationApplications.vue?vue&type=style&index=0&id=00bad48a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bad48a",
  null
  
)

export default component.exports